import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { ImpersonationBanner } from '@/components/shared/ImpersonationBanner';

/** Auth talab qilinadigan barcha route'lar buni ishlatadi */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // Impersonation paneli SHU YERDA: har bir himoyalangan sahifada ko'rinadi
  // va router kontekstidan ichkarida turadi (`useNavigate` ishlashi uchun).
  // `ImpersonationBanner` impersonation yo'q bo'lsa `null` qaytaradi.
  return (
    <>
      <ImpersonationBanner />
      {children}
    </>
  );
}
